import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigLeft: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M18 15h-6v4l-7-7 7-7v4h6v6z' }]],
];

export default ArrowBigLeft;
